import type { StaticTextResource } from '../keys'

export const pt: StaticTextResource = {
  'schedule.dueToday': 'Hoje até {{time}}',
  'schedule.dueTomorrow': 'Amanhã até {{time}}',
  'schedule.durationRange':
    '{{start}} - {{end}} (Dia {{currentDay}} / {{days}} dias)',
  'editReport.defaultPageName': 'Página {{n}}',
  'editReport.defaultSectionName': 'Seção',
  'editReport.defaultRepeatSectionName': 'Seção repetível',
}
